import { render } from "./NewAppFooter.vue?vue&type=template&id=84788126&scoped=true"
import script from "./NewAppFooter.vue?vue&type=script&lang=js"
export * from "./NewAppFooter.vue?vue&type=script&lang=js"

import "./NewAppFooter.vue?vue&type=style&index=0&id=84788126&lang=scss&scoped=true"

import exportComponent from "/Users/intr0vert/Git/ai-startup/aibanner/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84788126"]])

export default __exports__